import React from 'react';

export const name = 'flag-CY';

export const FlagCY = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_73)">
      <mask
        id="mask0_2_73"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_73)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M18.7828 10.4344H17.2172C17.2172 11.818 16.6675 13.1451 15.6891 14.1235C14.7107 15.1019 13.3837 15.6516 12 15.6516C10.6163 15.6516 9.28932 15.1019 8.3109 14.1235C7.33247 13.1451 6.78282 11.818 6.78282 10.4344H5.21719C5.21719 13.5375 7.30313 16.1531 10.1484 16.9594C9.99005 17.2591 9.92297 17.5986 9.95546 17.936C9.98794 18.2734 10.1186 18.5939 10.3313 18.8578L12.0328 17.4891L13.7391 18.8578C13.9531 18.5915 14.0838 18.268 14.1146 17.9277C14.1455 17.5875 14.0752 17.2457 13.9125 16.9453C15.3184 16.5313 16.5526 15.6734 17.4305 14.4998C18.3083 13.3262 18.7828 11.9 18.7828 10.4344Z"
          fill="#6DA544"
        />
        <path
          d="M7.82812 9.91407C7.82812 9.91407 7.82813 12.5203 10.4344 12.5203L10.9547 13.0453H12C12 13.0453 12.5203 11.4797 13.5656 11.4797C13.5656 11.4797 13.5656 10.4344 14.6109 10.4344H16.1719C16.1719 10.4344 15.6563 8.34845 18.2625 6.78282L17.2172 6.26251C17.2172 6.26251 13.5609 8.86876 10.9547 8.34845V9.38907H9.91406L9.38906 8.87345L7.82812 9.91407Z"
          fill="#FFDA44"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_73">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
